module.exports = __webpack_public_path__ + "assets/6-create-profile-to-browse-customer-success-manager-jobs.b7878220.png";